import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../../../i18n/i18n'
import './services-strip.scss'

type Item = { emoji: string; titulo: string; resumo: string }

export function ServicesStrip() {
  const navigate = useNavigate()
  const { t } = useI18n()
  const servicos = t('services.items') as Item[]

  return (
    <section className="services-strip">
      <div className="services-strip__head">
        <span className="eyebrow">{t('services.eyebrow')}</span>
        <h2 className="section-heading">{t('services.title')}</h2>
      </div>

      <div className="services-strip__row">
        {servicos.map((s, i) => (
          <button className="services-strip__card" key={i} onClick={() => navigate('/servicos')}>
            <span className="services-strip__emoji" aria-hidden>{s.emoji}</span>
            <h3 className="services-strip__titulo">{s.titulo}</h3>
            <p className="services-strip__resumo">{s.resumo}</p>
            <span className="services-strip__link">{t('services.link')} →</span>
          </button>
        ))}
      </div>
    </section>
  )
}
